import {
  handlerGetUrlParams
} from '@/utils/dealUrlParams'
import request from '@/utils/request'


// 查看详细信息
export function getVideoInfoDetail(id) {
  return request({
    url: `/bus/video/home/${id}`,
    method: 'GET'
  })
}

// 修改视频
export function updateVideoInfo(data) {
  return request({
    url: '/bus/video',
    method: 'PUT',
    data
  })
}

// 前台获取视频列表
export function getVideoList(params, data) {
  const url = handlerGetUrlParams(`/bus/video/home/list`, params)
  return request({
    url,
    method: 'POST',
    data
  })
}

// 后台获取视频数据列表
export function getBackStageVideoList(params) {
  const url = handlerGetUrlParams(`/bus/video/list`, params)
  return request({
    url,
    method: 'GET'
  })
}

// 删除视频
export function deleteVideoInfo(data) {
  return request({
    url: `/bus/video/batch/del`,
    method: 'POST',
    data
  })
}

// 新增视频
export function addVideoInfo(data) {
  return request({
    url: `/bus/video`,
    method: 'POST',
    data
  })
}

// 发布 or 下架
export function changeVideInfoStatus(data) {
  return request({
    url: `/bus/video/status`,
    method: 'PUT',
    data
  })
}

// 增加浏览量
export function viewsVideInfo(id) {
  return request({
    url: `/bus/video/is_view/${id}`,
    method: 'PUT',
  })
}